module.exports = __webpack_public_path__ + "img/bgc5.dff8d7e8.png";